<template>
  <div class="app-line-chart" :style="{  width: width, height: height }">
    <div class="app-line-chart__nodata" v-show="!hasData">暂无数据</div>
    <div class="app-line-chart__main" ref="chart"></div>
  </div>
</template>

<script>
import echarts from 'echarts'
import { debounce } from '@/utils'

export default {
  name: 'AppLineChart',
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object
    }
  },

  data () {
    return {
      chart: null
    }
  },

  computed: {
    hasData () {
      return this.chartData.series.length && this.chartData.series[0].data.length
    }
  },

  mounted () {
    this.initChart(this.chartData)
    this.addEvent()
  },

  beforeDestroy () {
    this.removeEvent()
  },

  watch: {
    chartData: {
      deep: true,
      handler (value) {
        if (this.chart) {
          this.setOptions(value)
        } else {
          this.initChart(value)
        }
      }
    }
  },

  methods: {
    addEvent () {
      if (this.autoResize) {
        this.__resizeHanlder = debounce(() => {
          if (this.chart) {
            this.chart.resize()
          }
        }, 100)
        window.addEventListener('resize', this.__resizeHanlder)
      }

      // 监听侧边栏的变化
      const sidebarElm = document.querySelector('.app-layout-sub__left')
      if (sidebarElm) {
        sidebarElm.addEventListener('transitionend', this.__resizeHanlder)
      }
    },

    removeEvent () {
      if (!this.chart) return
      if (this.autoResize) {
        window.removeEventListener('resize', this.__resizeHanlder)
      }

      const sidebarElm = document.querySelector('.app-layout-sub__left')
      if (sidebarElm) {
        sidebarElm.removeEventListener('transitionend', this.__resizeHanlder)
      }

      this.chart.dispose()
      this.chart = null
    },

    setOptions ({ tooltip, series }) {
      if (!this.chart) return
      this.chart.setOption({
        grid: {
          left: 20,
          right: 40,
          bottom: 20,
          top: 20,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: { color: '#666' },
          axisLine: { lineStyle: { color: '#ccc' } }
        },
        yAxis: {
          show: true,
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { lineStyle: { color: '#eee' } }
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, .75)',
          borderColor: '#ccc',
          borderWidth: 1,
          axisPointer: { type: 'line' },
          textStyle: { color: '#666' },
          formatter: tooltip.formatter
        },
        series: series
      })
    },

    initChart (chartData) {
      if (chartData.series.length && chartData.series[0].data.length) {
        this.chart = echarts.init(this.$refs.chart)
        this.setOptions(chartData)
      }
    }

  }
}
</script>

<style lang="scss">
.app-line-chart {
  position: relative;

  &__main {
    width: 100%;
    height: 100%;
  }

  &__nodata {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding-top: 100px;
    text-align: center;
    color: #999;
  }
}
</style>
